var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-list"},[_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.key},[_c('span',[_vm._v(_vm._s(item.label))]),_c('span',[_vm._v(_vm._s(item.value))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }